import './ConnectMarketplaceDashboard.scss';
import { DateTimeHelper } from '../../utils/dateTimeHelper';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { paths } from '../../routing/path';
import { Breadcrumb, BreadcrumbItem, Card } from 'reactstrap';
import { HomeButton } from '../../components/HomeButton/home-button';
import Layout from '../../components/Layout';
import { Tooltip } from 'react-tooltip';
import { createPortal } from 'react-dom';
import MyEngagement from './MyEngagement/MyEngagement';
import { useStateSelector } from '../../store/selectors';
import { UpdateLastActiveEngagement } from '../../slices/user-summary/update-last-active-engagement.thunk';
import Helpers from '../../utils/helper';
import EngagementBuyers from './Buyers/EngagementBuyers';
import { useDispatch } from 'react-redux';
import vvConnectLogo from '../../assets/demo-ui/images/VetValueConnect.png';
import {
    SellerMarketplaceTab,
    SellerMarketplaceTabs,
} from '../../slices/marketplace/timeline/models/enums/seller-marketplace-tab.enum';
import EngagementTimeline from './EngagementTimeline/EngagementTimeline';
import {
    BuyerSelectionOptionsList,
    NdaTermSelectionOptionsList,
    TimelineActionType,
} from '../../slices/marketplace/timeline/models/timeline-action-type.model';
import SellersEngagementDocuments from './EngagementDocuments/SellersEngagementDocuments/SellersEngagementDocuments';
import NdaTermsPopup from './NdaTermsPopup/NdaTermsPopup';
import NoPageAccessAlert from '../../components/NoPageAccessAlert/NoPageAccessAlert';
import ContactSupportButton from '../ContactSupportButton/ContactSupportButton';
import { SupportContextEnum } from '../../support-portal/models/SupportContext';
import TeaserInfoModal from '../AdminMarketplace/TeaserInfoModal/TeaserInfoModal';
import BuyerSelectionPopup from './BuyerSelectionPopup/BuyerSelectionPopup';
import DeadlineDocket from './DeadlineDocket/DeadlineDocket';
import { useFeatureFlag } from '../../custom-hooks/useFeatureFlag';
import { FeatureFlagsEnum } from '../FeatureFlags/FeatureFlags.enum';
import { DataAndDocsTab } from './DataAndDocsTab/DataAndDocsTab';
import { TimelineEventStatus } from '../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import { EngagementProcessStatus } from '../../slices/marketplace/timeline/models/enums/engagement-process-status.enum';
import { TimelineEvent } from '../../slices/marketplace/timeline/models/timeline-event.model';
import { TimelineTempo } from '../../slices/marketplace/timeline/models/enums/timeline-tempo.enum';
import { TimelineEventSortingService } from '../AdminMarketplace/TimelinePage/TimelineEventSortingService';
import MarketplaceSettings from '../AdminMarketplace/MarketplaceTabs/MarketplaceSettings/MarketplaceSettings';
import { GetTimelineById } from '../../slices/marketplace/timeline/thunks/get-timeline-by-id.thunk';
import { MarketplaceCommsHub } from '../AdminMarketplace/MarketplaceTabs/MarketplaceCommsHub/MarketplaceCommsHub';
import { PaymentValidator } from './PaymentValidator/PaymentValidator';
import { LoadMarketplacePricing } from '../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import EngagementHistoryTable from '../../components/EngagementHistoryTable/EngagementHistoryTable';
import { TimelineParty } from '../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import ValueRangeModal from '../Admin/BuyerMarketplace/ValueRangeModal/ValueRangeModal';
import {
    getMarketplaceCommsHubTabs,
    MarketplaceCommsHubTab,
    MarketplaceCommsHubMeetingsTab,
} from '../AdminMarketplace/MarketplaceTabs/MarketplaceCommsHub/MarketplaceCommsHubTabs';
import { useHasMeetingsOrClips } from '../../custom-hooks/useHasMeetingsOrClips';
import { useCurrentMarketplaceParty } from '../../custom-hooks/useCurrentMarketplaceParty';
import { NotificationFlag } from '../../components/NotificationFlag/NotificationFlag';
import { NotificationFlagsCategories } from '../../models/NotificationFlags/NotificationFlagsCategories';
import { RefreshNotificationFlags } from '../../slices/notification-flags/refresh-notification-flags';
import { LevelOfService } from '../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { SelectProfile } from '../../slices/profiles-data-slice/thunks/select-profile.thunk';
import { useSignalR } from '../../context/WebsocketProvider';
import { EngagementBuyer } from '../../slices/marketplace/timeline/models/engagement-buyer.model';
import { MarketplaceBuyer } from '../../slices/marketplace/buyer/models/buyer';
import { MarketplaceSellerProfileComponent } from '../../components/MarketplaceSellerProfile/MarketplaceSellerProfileComponent';
import VDRAccess from './VDRAccess/VDRAccess';
import EngagementDataRoomHost from './EngagementDataRoomHost/EngagementDataRoomHost';
import { USER_ROLES } from '../../utils/constants';
import { MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION } from '../../utils/associateMembersConstants';
import { LoiFormsTab } from './LoiFormsTab/LoiFormsTab';
import { MarketplaceFaqs } from '../AdminMarketplace/MarketplaceTabs/AdminFaqs/AdminFaqs';
import { LoiComparisonTab } from './LoiComparisonTab/LoiComparisonTab';
import {
    LogMarketplaceActivityRequest,
    MarketplaceActivityEvent,
} from './marketplace-activity-audit-log.model';

const ConnectMarketplaceDashboard = () => {
    const is28Implemented = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcSellers_2_8
    );
    const isFF_MrktplcBuyers_3_7Implemented = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcBuyers_3_7
    );
    const isFF_MrktplcBuyers_3_8Enabled = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcBuyers_3_8
    );
    const isFF_MrktplcSellers_2_13Enabled = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcSellers_2_13
    );
    const isFF_MrktplcSellers_2_15Enabled = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcSellers_2_15
    );

    const connection = useSignalR().connection;
    const isConnected = useSignalR().isConnected;

    const axios = useStateSelector((t) => t.core.axios);
    const navigate = useNavigate();
    const dispatch = useDispatch() as any;

    const summary = useStateSelector((state) => state.userSummary.summary);
    const currentUser = useStateSelector((state) => state.currentUser.user);
    const currentEngagement = useStateSelector(
        (state) => state.timelines.currentTimeline
    );

    const [searchParams, setSearchParams] = useSearchParams({});
    const engagementId = Number(useParams().engagementId);

    const party = useCurrentMarketplaceParty(engagementId);
    const hasMeetingsOrClips = useHasMeetingsOrClips(engagementId);

    const isAdmin = party === TimelineParty.VetValue;
    const isBroker = party === TimelineParty.Broker;
    const isObserver = party === TimelineParty.Observer;

    const [isNdaTermPopupVisible, setIsNdaTermPopupVisible] = useState(false);
    const [isBuyerSelectionPopupVisible, setIsBuyerSelectionPopupVisible] =
        useState(false);
    const [isTeaserInfoModalVisible, setIsTeaserInfoModalVisible] =
        useState(false);

    const [systemBuyers, setSystemBuyers] = useState<MarketplaceBuyer[]>([]);

    const [activeEventId, setActiveEventId] = useState<string>('');

    const [activeTab, setActiveTab] = useState<number>(
        SellerMarketplaceTab.MyEngagement
    );
    const [highlightItemId, setHighlightItemId] = useState('');
    const [isRangeOfValueVisible, setIsRangeOfValueVisible] = useState(false);
    const [buyerValueRangeInterest, setBuyerValueRangeInterest] = useState<{
        minValue: number;
        maxValue: number;
    } | null>(null);

    const [isEngagementLoading, setIsEngagementLoading] =
        useState<boolean>(true);
    const [isSystemBuyersLoading, setIsSystemBuyersLoading] =
        useState<boolean>(true);

    const [events, setEvents] = useState<TimelineEvent[]>([]);
    const [
        engagementHistoryRefreshTrigger,
        setEngagementHistoryRefreshTrigger,
    ] = useState(false);

    const [availableBuyers, setAvailableBuyers] = useState<EngagementBuyer[]>(
        []
    );

    const [
        isPracticeOfCurrentUserAndIsInEngagement,
        setIsPracticeOfCurrentUserAndIsInEngagement,
    ] = useState<boolean>(false);

    const isEngagementActive = () => {
        if (!currentEngagement || !currentEngagement?.engagementProcess) {
            return false;
        }
        const status = currentEngagement?.engagementProcess?.status;
        return status === EngagementProcessStatus.Current;
    };

    const isTeamMemberWithReadonlyAccess = () => {
        var isTeamMemberWithReadonlyAccess =
            summary.roleId == USER_ROLES.PRACTICE_SECONDARY_USER &&
            (summary.associateMember as any[]).some(
                (am) =>
                    am.associateMemberMarketplaceMappings &&
                    (am.associateMemberMarketplaceMappings as any[]).some(
                        (mapping) =>
                            mapping.isSellerSide &&
                            mapping.engagementId == engagementId
                    )
            );

        return isTeamMemberWithReadonlyAccess;
    };

    const getSellerTMCurrentPermissions = (): number[] => {
        if (summary.roleId !== USER_ROLES.PRACTICE_SECONDARY_USER) return [];
        for (const am of summary.associateMember as any[]) {
            if (!am.associateMemberMarketplaceMappings) continue;
            for (const mapping of am.associateMemberMarketplaceMappings) {
                if (
                    mapping.isSellerSide &&
                    mapping.engagementId == engagementId &&
                    mapping.currentSellerTMPermissions?.length > 0
                ) {
                    return (mapping.currentSellerTMPermissions as any[]).map(
                        Number
                    );
                }
            }
        }
        return [];
    };

    const isSellerTeamMemberWithoutCommsHub = () => {
        const perms = getSellerTMCurrentPermissions();
        return (
            perms.length > 0 &&
            !perms.includes(MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.CommsHub)
        );
    };

    const isCommsHubReadOnly = () => isSellerTeamMemberWithoutCommsHub() || isObserver;

    const isReadOnly = () => {
        return (
            isObserver ||
            isTeamMemberWithReadonlyAccess() ||
            !isEngagementActive()
        );
    };

    const isDataAndDocsTabReadOnly = () => {
        const hasPracticeDataAndDocs =
            summary.roleId == USER_ROLES.PRACTICE_SECONDARY_USER &&
            (summary.associateMember as any[]).some(
                (am) =>
                    am.associateMemberMarketplaceMappings &&
                    (am.associateMemberMarketplaceMappings as any[]).some(
                        (mapping) =>
                            mapping.isSellerSide &&
                            mapping.engagementId == engagementId &&
                            mapping.currentSellerTMPermissions &&
                            (mapping.currentSellerTMPermissions as any[]).some(
                                (sellerPerm) =>
                                    sellerPerm ==
                                    MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.PracticeDataAndDocs
                            )
                    )
            );
        if (hasPracticeDataAndDocs) return !isEngagementActive();
        return isReadOnly();
    };

    const onDisconnect = () => {
        connection?.off('MP_RefreshTimeline');
        connection?.off('MP_RefreshNotificationFlags');
    };

    const logMarketplaceActivity = (request: LogMarketplaceActivityRequest) => {
        axios
            .post('/api/marketplace/MarketplaceActivityAuditLogs', request)
            .catch(() => {});
    };

    useEffect(() => {
        if (engagementId && !isAdmin && engagementId !== summary.lastActiveEngagementId) {
            dispatch(UpdateLastActiveEngagement(engagementId));
        }
    }, [engagementId]);

    useEffect(() => {
        dispatch(LoadMarketplacePricing(engagementId));
        return () => {
            onDisconnect();
        };
    }, []);

    const fetchEngagementAndAvailableBuyers = async (
        fetchBuyers: boolean = true,
        noLoader: boolean = true
    ) => {
        if (!noLoader) setIsEngagementLoading(true);
        const timelinePromise = dispatch(
            GetTimelineById({ id: engagementId, isTemplate: false })
        );
        try {
            await Promise.all(
                !fetchBuyers
                    ? [timelinePromise]
                    : [
                          axios
                              .get(
                                  `/api/Marketplace/Engagements/SFAS/${engagementId}/AvailableBuyers`
                              )
                              .then((response) => {
                                  setAvailableBuyers(response.data);
                              }),
                          timelinePromise,
                      ]
            );
        } finally {
            setIsEngagementLoading(false);
        }
    };

    useEffect(() => {
        if (isConnected) {
            connection.on('MP_RefreshTimeline', () => {
                fetchEngagementAndAvailableBuyers(true, false).then();
                dispatch(RefreshNotificationFlags());
            });
            connection.on('MP_RefreshNotificationFlags', () => {
                dispatch(RefreshNotificationFlags());
            });
        }
    }, [isConnected]);

    useEffect(() => {
        if (!isAdmin) {
            setIsPracticeOfCurrentUserAndIsInEngagement(
                summary?.engagements?.some((p: any) => p.id === engagementId)
            );
        }
    }, [summary]);

    useEffect(() => {
        fetchEngagementAndAvailableBuyers(true, false).then();
        if (engagementId) {
            logMarketplaceActivity({ engagementId, event: MarketplaceActivityEvent.MarketplaceOpened });
        }
    }, [engagementId]);

    const fetchSystemBuyers = () => {
        axios
            .get(`api/Marketplace/MarketplaceBuyers/all/${engagementId}`)
            .then((response) => {
                if (response.status === 200) {
                    setSystemBuyers(response.data);
                }
            })
            .finally(() => {
                setIsSystemBuyersLoading(false);
            });
    };

    useEffect(() => {
        if (isAdmin || isBroker) fetchSystemBuyers();
        else setIsSystemBuyersLoading(false);
    }, []);

    useEffect(() => {
        if (currentEngagement && Array.isArray(currentEngagement.events)) {
            setEvents(currentEngagement.events);
        }

        setEngagementHistoryRefreshTrigger((prev) => !prev);

        if (currentEngagement?.engagementProcess?.sellerProfileId) {
            dispatch(
                SelectProfile(
                    currentEngagement?.engagementProcess?.sellerProfileId
                )
            );
        }
    }, [currentEngagement]);

    useEffect(() => {
        const value = searchParams.get('tab');
        const numberValue = Number(value);
        if (
            value &&
            numberValue &&
            numberValue >= 1 &&
            numberValue <= tabComponents.length
        ) {
            setActiveTab(numberValue);
            const tabName = SellerMarketplaceTabs.find((t) => t.id === numberValue)?.label;
            if (tabName && engagementId) {
                logMarketplaceActivity({
                    engagementId,
                    event: MarketplaceActivityEvent.TabVisited,
                    tabName,
                });
            }
        } else {
            updateSearchParams({
                tab: (1).toString(),
            });
        }
    }, [searchParams]);

    const updateSearchParams = (params: { [key: string]: string }) => {
        const newParams: Record<string, string> = {};
        newParams.tab = params.tab ?? activeTab.toString();
        if (params.subtab !== undefined) {
            newParams.subtab = params.subtab;
        }
        if (params.meetingstab !== undefined) {
            newParams.meetingstab = params.meetingstab;
        }
        setSearchParams(newParams);
    };

    const navigateToDocument = (documentId: string) => {
        setHighlightItemId(documentId);
        navigateToTab(SellerMarketplaceTab.EngagementDocuments);
    };

    const navigateToProject = (projectId: string) => {
        setHighlightItemId(projectId);
        navigateToTab(SellerMarketplaceTab.DataAndDocs);
    };

    const navigateToBuyers = () => {
        navigateToTab(SellerMarketplaceTab.Buyers);
    };

    const navigateToMeetings = () => {
        updateSearchParams({
            tab: Number(SellerMarketplaceTab.CommsHub).toString(),
            subtab: Number(MarketplaceCommsHubTab.Meetings).toString(),
            ...(party !== TimelineParty.Buyer && {
                meetingstab: Number(MarketplaceCommsHubMeetingsTab.BuyerMeetings).toString(),
            }),
        });
    };

    const navigateToMeetingScheduling = () => {
        updateSearchParams({
            tab: Number(SellerMarketplaceTab.CommsHub).toString(),
            subtab:
                party !== TimelineParty.Buyer
                    ? Number(MarketplaceCommsHubTab.Meetings).toString()
                    : Number(MarketplaceCommsHubTab.MeetingScheduling).toString(),
            ...(party !== TimelineParty.Buyer && {
                meetingstab: Number(
                    MarketplaceCommsHubMeetingsTab.BuyerMeetingScheduling
                ).toString(),
            }),
        });
    };

    const teaserEvent = currentEngagement?.events.find(
        (event) =>
            event.linkedAction?.actionType ===
            TimelineActionType.SellerTeaserApproval
    );

    const tabComponents = [
        {
            id: SellerMarketplaceTab.MyEngagement,
            content: () => (
                <MyEngagement
                    fetchData={() => fetchEngagementAndAvailableBuyers().then()}
                    isAdminView={isAdmin}
                    isReadOnly={isReadOnly()}
                    isRestrictedAccess={isObserver || isTeamMemberWithReadonlyAccess()}
                    party={party}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementCode}`,
        },
        {
            id: SellerMarketplaceTab.EngagementDocuments,
            content: () => (
                <SellersEngagementDocuments
                    timelineId={currentEngagement.id}
                    currentEngagement={currentEngagement}
                    preSelectedDocumentId={highlightItemId}
                    resetPreSelectedDocumentId={() => setHighlightItemId(null)}
                    isReadOnly={isReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementDocumentsCode}`,
        },
        {
            id: SellerMarketplaceTab.EngagementTimeline,
            content: () => (
                <EngagementTimeline
                    id={currentEngagement.id}
                    events={events}
                    startDate={currentEngagement.engagementProcess.startDate}
                    currentDate={
                        currentEngagement.simulatedNowUtc
                            ? DateTimeHelper.parseUtc(currentEngagement.simulatedNowUtc)
                            : undefined
                    }
                    setSearchParams={updateSearchParams}
                    engagementData={currentEngagement.engagementData}
                    engagementProcess={currentEngagement.engagementProcess}
                    onEventClick={onEventClick}
                    tempo={currentEngagement.tempo}
                    levelOfService={currentEngagement.levelOfService}
                    fetchData={() => fetchEngagementAndAvailableBuyers().then()}
                    recalculateEventsBasedOnTempo={
                        recalculateEventsBasedOnTempo
                    }
                    isReadOnly={isReadOnly()}
                    isBuyerView={false}
                    hideExecuteButton={
                        getSellerTMCurrentPermissions().length > 0
                    }
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementTimelinePreviewCode}`,
        },
        {
            id: SellerMarketplaceTab.Buyers,
            content: () => (
                <EngagementBuyers
                    currentParty={party}
                    engagementTimeline={currentEngagement}
                    fetchData={fetchEngagementAndAvailableBuyers}
                    navigateToDocument={navigateToDocument}
                    availableBuyers={availableBuyers}
                    systemBuyers={systemBuyers || []}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.BuyersCode}`,
        },
        {
            id: SellerMarketplaceTab.DeadlineDocket,
            content: () => (
                <DeadlineDocket
                    engagementId={currentEngagement.id}
                    engagementStartDate={
                        currentEngagement.engagementProcess.startDate
                    }
                    engagementData={currentEngagement.engagementData}
                    onEventClick={onEventClick}
                    events={currentEngagement.events}
                    dataRequestProjects={
                        currentEngagement.engagementData?.dataRequestProjects
                    }
                    isReadonly={isReadOnly()}
                    notificationFlagPrefix={`${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.DeadlineDocketCode}`}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.DeadlineDocketCode}`,
        },
        {
            id: SellerMarketplaceTab.DataAndDocs,
            content: () => (
                <DataAndDocsTab
                    engagementId={currentEngagement.id}
                    preSelectedProjectId={highlightItemId}
                    resetPreSelectedProjectId={() => setHighlightItemId(null)}
                    isReadOnly={isDataAndDocsTabReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.DataAndDocsCode}`,
        },
        {
            id: SellerMarketplaceTab.Settings,
            content: () =>
                isAdmin &&
                currentEngagement.levelOfService !==
                    LevelOfService.StrategicFinancialAdvisoryService ? (
                    <MarketplaceSettings
                        isTemplate={false}
                        engagementId={currentEngagement.id}
                        engagementLevelOfService={
                            currentEngagement.levelOfService
                        }
                    />
                ) : (
                    <></>
                ),
        },
        {
            id: SellerMarketplaceTab.CommsHub,
            content: () => (
                <MarketplaceCommsHub
                    engagementId={currentEngagement.id}
                    notificationFlagPrefix={`${NotificationFlagsCategories.MpCode}`}
                    engagement={currentEngagement}
                    meetingsGroupId={currentEngagement.meetingsGroupId}
                    setSearchParams={updateSearchParams}
                    isReadOnly={isCommsHubReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.CommsHubCode}`,
        },
        {
            id: SellerMarketplaceTab.EngagementHistory,
            content: () => (
                <EngagementHistoryTable
                    engagementId={currentEngagement.id}
                    events={currentEngagement.events}
                    engagementData={currentEngagement.engagementData}
                    viewParty={party}
                    canNavigateToTransaction={!isAdmin}
                    onEventClick={onEventClick}
                    isReadonly={isReadOnly()}
                    refreshTrigger={engagementHistoryRefreshTrigger}
                    buyers={currentEngagement.engagementProcess?.buyers ?? []}
                    onAdminClickBuyerEvent={onAdminClickBuyerEvent}
                    sellerId={currentEngagement.engagementProcess.userId}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.EngagementHistoryCode}.${NotificationFlagsCategories.EngagementAutoPaymentCode}`,
        },
        {
            id: SellerMarketplaceTab.SellerProfile,
            content: () => (
                <MarketplaceSellerProfileComponent
                    inReadonly={isReadOnly()}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${currentEngagement?.id}.${NotificationFlagsCategories.SellerProfileUpdatedCode}`,
            inReadonly: isReadOnly(),
        },
        {
            id: SellerMarketplaceTab.DataRoomLayout,
            content: () => <EngagementDataRoomHost isReadonly={isReadOnly()} />,
        },
        {
            id: SellerMarketplaceTab.VDRAccess,
            content: () => (
                <VDRAccess
                    currentEngagement={currentEngagement}
                    availableBuyers={availableBuyers}
                />
            ),
        },
        {
            id: SellerMarketplaceTab.Lois,
            content: () => (
                <LoiFormsTab
                    engagementId={currentEngagement.id}
                    events={events}
                    levelOfService={currentEngagement.levelOfService}
                    isAdmin={isAdmin}
                    engagedBuyerId={
                        currentEngagement.engagementProcess?.buyers.find(
                            (b) => b.isLoiSelected
                        )?.buyerId ?? null
                    }
                />
            ),
        },
        {
            id: SellerMarketplaceTab.FAQs,
            content: () => <MarketplaceFaqs isAdmin={false} engagementId={engagementId} />,
        },
        {
            id: SellerMarketplaceTab.LoiComparison,
            content: () => (
                <LoiComparisonTab
                    engagementId={currentEngagement.id}
                    levelOfService={currentEngagement.levelOfService}
                    setSearchParams={updateSearchParams}
                    isSeller={party === TimelineParty.Seller}
                    isBroker={isBroker}
                    loiComparisonEventId={
                        currentEngagement.events.find(
                            (e) => e.linkedAction?.actionType === TimelineActionType.SellerLoiComparison
                        )?.id ?? null
                    }
                    isEventCompleted={
                        currentEngagement.events.find(
                            (e) => e.linkedAction?.actionType === TimelineActionType.SellerLoiComparison
                        )?.status === TimelineEventStatus.Completed
                    }
                    fetchData={() => fetchEngagementAndAvailableBuyers().then()}
                />
            ),
        },
    ];

    const navigateToTab = (tab: SellerMarketplaceTab) => {
        updateSearchParams({
            tab: Number(tab).toString(),
        });
    };

    const recalculateEventsBasedOnTempo = (tempo: TimelineTempo) => {
        const newEvents = TimelineEventSortingService.sortTimelineEvents(
            currentEngagement.events,
            currentEngagement.levelOfService,
            tempo,
            currentEngagement.engagementProcess?.startDate
        );
        setEvents(newEvents);
    };

    const onEventClick = (eventId: string) => {
        const guid = eventId.replace('event-', '');
        const events = currentEngagement.events;
        const selectedEvent = events.find((x) => x.id == guid);
        if (!selectedEvent?.linkedAction) return;
        const linkedBuyerReviewAction =
            selectedEvent.linkedAction.actionType ===
                TimelineActionType.BuyerReviewDocument &&
            ((!!selectedEvent.linkedAction?.actionReferenceId &&
                !!events.find(
                    (e) =>
                        e.linkedAction &&
                        e.linkedAction?.id ==
                            selectedEvent.linkedAction?.actionReferenceId
                )) ||
                selectedEvent.linkedAction?.referenceItemId);

        if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerCustomSelectLoiAndDdNdaTerms
        ) {
            if (isAdmin) {
                navigateToTab(SellerMarketplaceTab.Lois);
            } else {
                const engagedBuyer = currentEngagement.engagementProcess?.buyers.find(
                    (b) => b.isLoiSelected
                );
                const actionState = engagedBuyer?.actionState.find(
                    (a) => a.actionId == selectedEvent.linkedAction?.id
                );
                if (actionState?.documentDetailsId) {
                    navigateToDocument(actionState.documentDetailsId);
                } else {
                    navigateToTab(SellerMarketplaceTab.EngagementDocuments);
                }
            }
        } else if (
            BuyerSelectionOptionsList.some((option) => {
                return option.value === selectedEvent.linkedAction?.actionType;
            })
        ) {
            setActiveEventId(selectedEvent.id);
            setIsBuyerSelectionPopupVisible(true);
        } else if (
            NdaTermSelectionOptionsList.some((option) => {
                return option.value === selectedEvent.linkedAction?.actionType;
            })
        ) {
            setActiveEventId(selectedEvent.id);
            setIsNdaTermPopupVisible(true);
        } else if (
            TimelineActionType.SellerEngagementDocument ===
                selectedEvent.linkedAction?.actionType ||
            linkedBuyerReviewAction
        ) {
            navigateToDocument(selectedEvent.linkedAction.referenceItemId);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerTeaserApproval
        ) {
            setIsTeaserInfoModalVisible(true);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerDataAndDocumentRequest
        ) {
            navigateToProject(selectedEvent.linkedAction.referenceItemId);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.VetValueBuyerSelectionAndTeaserPosting
        ) {
            navigateToBuyers();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerProvideMeetingAvailability
        ) {
            navigateToMeetingScheduling();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerBuyerAgreeOnMeetingTimes
        ) {
            navigateToMeetingScheduling();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerBuyerMeetingsPeriod
        ) {
            navigateToMeetings();
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerProfile
        ) {
            navigateToTab(SellerMarketplaceTab.SellerProfile);
        } else if (
            selectedEvent.linkedAction?.actionType ==
            TimelineActionType.SellerLoiComparison
        ) {
            navigateToTab(SellerMarketplaceTab.LoiComparison);
        }
    };

    const onAdminClickBuyerEvent = (eventId: string, buyerId: number) => {
        const events = currentEngagement.events;
        const targetEvent = events.find((x) => x.id == eventId);

        const targetBuyer = currentEngagement.engagementProcess?.buyers.find(
            (b) => b.buyerId === buyerId
        );
        const targetActionState = targetBuyer?.actionState.find(
            (f) => f.actionId === targetEvent.linkedAction?.id
        );

        switch (targetEvent.linkedAction?.actionType) {
            case TimelineActionType.SellerBuyerSelectionIdNda:
            case TimelineActionType.SellerCustomSelectDataNdaTerms:
            case TimelineActionType.BuyerUploadDocument:
            case TimelineActionType.BuyerDocumentExecution:
                const targetBuyerDocumentId =
                    targetActionState?.documentDetailsId;
                if (targetBuyerDocumentId) {
                    navigateToDocument(targetBuyerDocumentId);
                }
                return;
            case TimelineActionType.BuyerExpressionOfInterestWithRange:
                if (targetActionState) {
                    setBuyerValueRangeInterest({
                        minValue: targetActionState?.minPrice ?? 0,
                        maxValue: targetActionState?.maxPrice ?? 0,
                    });
                    setIsRangeOfValueVisible(true);
                }
                return;
            case TimelineActionType.BuyerReviewDocument:
                let targetReviewDocumentId =
                    targetEvent.linkedAction?.referenceItemId;
                if (targetEvent.linkedAction?.actionReferenceId) {
                    const targetReferenceEvent = events.find(
                        (e) =>
                            e.linkedAction?.id ===
                            targetEvent.linkedAction?.actionReferenceId
                    );
                    targetReviewDocumentId =
                        targetReferenceEvent.linkedAction?.referenceItemId;
                }

                if (targetReviewDocumentId) {
                    navigateToDocument(targetReviewDocumentId);
                }

                return;
        }
    };

    const renderTabContent = () => {
        const activeTabData = tabComponents.find((tab) => tab.id === activeTab);
        return activeTabData ? activeTabData.content() : <></>;
    };

    const getTabNotificationFlag = (tab: number) => {
        const targetCode = tabComponents.find((t) => t.id === tab);
        return targetCode ? (
            <>
                <NotificationFlag
                    flagClassName="notification-flag-wrapper"
                    eventCode={targetCode.notificationFlag}
                    includePrefix={true}
                />
            </>
        ) : (
            <></>
        );
    };

    const renderTabs = () => {
        return (
            <Card
                className={`main-card gantt-chart-container marketplace-dynamic-container`}>
                <div className="body_white_box practice-page-tabs m-0 gantt-chart-container marketplace-dynamic-container">
                    <div className="body_inner_content gantt-chart-container marketplace-dynamic-container">
                        <div className="RRT__container">
                            <div className="RRT__tabs body-tabs">
                                {SellerMarketplaceTabs?.filter((x) =>
                                    shouldShowTab(x)
                                ).map((item) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className={
                                                activeTab === item.id
                                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                                    : 'RRT__tab'
                                            }
                                            data-tooltip-id="seller-tab-tooltip"
                                            data-tooltip-content={item.tooltip}
                                            onClick={() => {
                                                setActiveTab(item.id);
                                                updateSearchParams({
                                                    tab: item.id.toString(),
                                                });
                                                dispatch(
                                                    RefreshNotificationFlags()
                                                );
                                            }}>
                                            {item.label}
                                            {getTabNotificationFlag(item.id)}
                                        </div>
                                    );
                                })}
                            </div>
                            {createPortal(
                                <Tooltip
                                    id="seller-tab-tooltip"
                                    place="bottom"
                                    className="portal-tooltip tooltip-content"
                                />,
                                document.body
                            )}
                        </div>
                        {renderTabContent()}
                    </div>
                </div>
            </Card>
        );
    };

    const renderConnectMarketplaceDashboardPage = () => {
        const fteDvms = currentEngagement?.engagementProcess?.startFteDvm || 0;
        return (
            <div
                className={`marketplace-dynamic-container ${
                    activeTab === SellerMarketplaceTab.EngagementTimeline
                        ? 'marketplace-dashboard-adapt-timeline-preview'
                        : ''
                }`}>
                {isEngagementLoading || isSystemBuyersLoading ? (
                    Helpers.renderPageLoader()
                ) : (currentEngagement &&
                      (isPracticeOfCurrentUserAndIsInEngagement ||
                          getSellerTMCurrentPermissions().length > 0) &&
                      !isAdmin) ||
                  isAdmin ? (
                    <>
                        <div className="main-title-content">
                            <div className="title-breadcrumb">
                                {!isAdmin ? (
                                    <div className="page-title">
                                        <div>
                                            <h3>
                                                Connect Marketplace Dashboard
                                            </h3>
                                            <Breadcrumb>
                                                <BreadcrumbItem>
                                                    <HomeButton />
                                                </BreadcrumbItem>
                                                <BreadcrumbItem active>
                                                    Connect Marketplace
                                                </BreadcrumbItem>
                                            </Breadcrumb>
                                        </div>
                                        <div className="vvconnect-logo">
                                            <img
                                                width={165}
                                                alt="VVConnect"
                                                src={vvConnectLogo}
                                            />
                                        </div>
                                        <div className="buttons-wrapper">
                                            <ContactSupportButton
                                                supportContext={
                                                    SupportContextEnum.Marketplace
                                                }
                                                buttonType="reference"
                                                buttonText="Contact Administrator"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="page-title">
                                            <h3>
                                                Seller Marketplace Dashboard
                                            </h3>
                                        </div>
                                        <Breadcrumb>
                                            <BreadcrumbItem>
                                                <HomeButton />
                                            </BreadcrumbItem>
                                            <BreadcrumbItem>
                                                <a
                                                    className="breadcrumb-link"
                                                    onClick={() =>
                                                        navigate(
                                                            paths.admin.marketplace
                                                        )
                                                    }>
                                                    Marketplace Admin Home
                                                </a>
                                            </BreadcrumbItem>
                                            <BreadcrumbItem active>
                                                Seller Marketplace
                                            </BreadcrumbItem>
                                        </Breadcrumb>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="gantt-chart-container marketplace-dynamic-container">
                            {renderTabs()}
                        </div>
                    </>
                ) : (
                    <NoPageAccessAlert />
                )}

                {isNdaTermPopupVisible && (
                    <NdaTermsPopup
                        isVisible={isNdaTermPopupVisible}
                        engagementData={currentEngagement.engagementData}
                        engagementProcess={currentEngagement.engagementProcess}
                        engagementId={currentEngagement.id}
                        events={currentEngagement.events}
                        fetchData={() =>
                            fetchEngagementAndAvailableBuyers().then()
                        }
                        activeEventId={activeEventId}
                        setIsVisible={setIsNdaTermPopupVisible}
                        levelOfService={currentEngagement.levelOfService}
                        isObserver={isObserver}
                    />
                )}

                {isBuyerSelectionPopupVisible && (
                    <BuyerSelectionPopup
                        isAdminView={isAdmin || isBroker || isObserver}
                        isReadOnly={isReadOnly()}
                        isVisible={isBuyerSelectionPopupVisible}
                        engagementData={currentEngagement.engagementData}
                        engagementProcess={currentEngagement.engagementProcess}
                        engagementId={currentEngagement.id}
                        events={currentEngagement.events}
                        fetchData={() =>
                            fetchEngagementAndAvailableBuyers().then()
                        }
                        activeEventId={activeEventId}
                        setIsVisible={setIsBuyerSelectionPopupVisible}
                        fteDvms={fteDvms}
                        levelOfService={currentEngagement.levelOfService}
                    />
                )}

                {isTeaserInfoModalVisible && (
                    <TeaserInfoModal
                        isReadOnly={
                            isReadOnly() ||
                            currentEngagement?.engagementData
                                .isTeaserConfirmed ||
                            teaserEvent?.status ===
                                TimelineEventStatus.Completed ||
                            currentEngagement?.engagementProcess?.status ===
                                EngagementProcessStatus.Completed
                        }
                        isVisible={isTeaserInfoModalVisible}
                        onClose={() => setIsTeaserInfoModalVisible(false)}
                        timelineId={currentEngagement.id}
                        teaserData={currentEngagement.engagementData.teaserData}
                        fetchData={() =>
                            fetchEngagementAndAvailableBuyers().then()
                        }
                    />
                )}

                {isRangeOfValueVisible ? (
                    <ValueRangeModal
                        isRangeOfValueVisible={isRangeOfValueVisible}
                        onClose={() => setIsRangeOfValueVisible(false)}
                        onRangeOfValueConfirm={() => {}}
                        selectedEventId={''}
                        isRangeOfValueReadonly={true}
                        minValue={buyerValueRangeInterest.minValue}
                        maxValue={buyerValueRangeInterest.maxValue}
                        isPreviewModeActive={true}
                    />
                ) : (
                    <></>
                )}
            </div>
        );
    };

    const isDeadlineDocketVisible = (tab: any) => {
        return (
            isAdmin ||
            tab.id !== SellerMarketplaceTab.DeadlineDocket ||
            currentEngagement?.engagementProcess?.status !==
                EngagementProcessStatus.Suspended
        );
    };

    const isTabVisibleForTerminatedStatus = (tab: any) => {
        return (
            currentEngagement?.engagementProcess?.status !==
                EngagementProcessStatus.Terminated ||
            tab.id === SellerMarketplaceTab.MyEngagement ||
            tab.id === SellerMarketplaceTab.EngagementDocuments
        );
    };

    const isCommsHubVisible = (tab: any) => {
        return (
            tab.id !== SellerMarketplaceTab.CommsHub ||
            (is28Implemented &&
                getMarketplaceCommsHubTabs(
                    party,
                    currentEngagement.levelOfService,
                    currentEngagement.engagementProcess?.buyers?.some(
                        (b) => b.isDataNdaSigned && b.isActive
                    ) ?? false,
                    !!currentEngagement?.engagementProcess?.broker
                        ?.brokerChatId &&
                        currentEngagement.engagementProcess.broker.isActive,
                    currentEngagement.events ?? [],
                    hasMeetingsOrClips,
                    party === TimelineParty.VetValue ||
                        party === TimelineParty.Broker,
                    false,
                    isFF_MrktplcSellers_2_13Enabled,
                    undefined,
                    currentEngagement.engagementProcess?.buyers?.some(
                        (b) => !!b.buyerCommsId
                    )
                ).length > 0)
        );
    };

    const isSettingsVisible = (tab: any) => {
        return (
            tab.id !== SellerMarketplaceTab.Settings ||
            (isAdmin &&
                currentEngagement.levelOfService !==
                    LevelOfService.StrategicFinancialAdvisoryService)
        );
    };

    const isSellerProfileVisible = (tab: any) => {
        return (
            tab.id !== SellerMarketplaceTab.SellerProfile ||
            isFF_MrktplcBuyers_3_7Implemented
        );
    };

    const isVDRAccessVisible = (tab: any) => {
        return tab.id !== SellerMarketplaceTab.VDRAccess || isAdmin;
    };
    const isDataRoomVisible = (tab: any) => {
        return (
            tab.id !== SellerMarketplaceTab.DataRoomLayout ||
            isFF_MrktplcBuyers_3_8Enabled
        );
    };

    const isFaqsVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.FAQs) return true;
        if (!isFF_MrktplcSellers_2_15Enabled) return false;
        return (
            party === TimelineParty.Seller ||
            party === TimelineParty.Broker ||
            party === TimelineParty.VetValue
        );
    };

    const isLoisVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.Lois) return true;
        if (!isAdmin) return false;
        const loiEvent = currentEngagement?.events?.find(
            (e) => e.linkedAction?.actionType === TimelineActionType.BuyerLoiSubmission
        );
        return !!loiEvent && loiEvent.status !== TimelineEventStatus.Upcoming;
    };

    const isLoiComparisonVisible = (tab: any) => {
        if (tab.id !== SellerMarketplaceTab.LoiComparison) return true;
        const loiComparisonEvent = currentEngagement?.events?.find(
            (e) => e.linkedAction?.actionType === TimelineActionType.SellerLoiComparison
        );
        return !!loiComparisonEvent && loiComparisonEvent.status !== TimelineEventStatus.Upcoming;
    };

    const isTabVisibleForSellerTM = (tab: any) => {
        if (party === TimelineParty.VetValue || party === TimelineParty.Broker)
            return true;
        if (currentEngagement?.engagementProcess?.userId === currentUser?.id)
            return true;
        const perms = getSellerTMCurrentPermissions();
        if (perms.length === 0) return true;
        if (
            perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.FullReadOnlyMarketplace
            )
        )
            return true;
        if (tab.id === SellerMarketplaceTab.MyEngagement) return true;
        if (tab.id === SellerMarketplaceTab.DataAndDocs)
            return perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.PracticeDataAndDocs
            );
        if (tab.id === SellerMarketplaceTab.CommsHub)
            return perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.CommsHub
            );
        if (tab.id === SellerMarketplaceTab.DataRoomLayout)
            return perms.includes(
                MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.DataRoom
            );
        return false;
    };

    const shouldShowTab = (tab: any) => {
        return (
            isDeadlineDocketVisible(tab) &&
            isTabVisibleForTerminatedStatus(tab) &&
            isCommsHubVisible(tab) &&
            isSettingsVisible(tab) &&
            isSellerProfileVisible(tab) &&
            isVDRAccessVisible(tab) &&
            isDataRoomVisible(tab) &&
            isLoisVisible(tab) &&
            isFaqsVisible(tab) &&
            isLoiComparisonVisible(tab) &&
            isTabVisibleForSellerTM(tab)
        );
    };

    return (
        <Layout>
            <div
                className={`connect-marketplace-dashboard ${
                    activeTab === SellerMarketplaceTab.CommsHub
                        ? ' marketplace-comms-hub-container'
                        : 'marketplace-tab-container'
                }`}>
                {renderConnectMarketplaceDashboardPage()}
            </div>
            {!isAdmin &&
                !isBroker &&
                !isTeamMemberWithReadonlyAccess() &&
                currentEngagement && (
                    <PaymentValidator
                        fetchEngagement={() =>
                            fetchEngagementAndAvailableBuyers(false).then()
                        }
                    />
                )}
        </Layout>
    );
};

export default ConnectMarketplaceDashboard;
